/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What resolution should a YouTube thumbnail be?`)
};

const es_yt_hd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Qué resolución debe tener una miniatura de YouTube?`)
};

const de_yt_hd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welche Auflösung sollte ein YouTube-Thumbnail haben?`)
};

const nl_yt_hd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Welke resolutie moet een YouTube-thumbnail hebben?`)
};

const fr_yt_hd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle résolution une miniature YouTube doit-elle avoir ?`)
};

const it_yt_hd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Che risoluzione dovrebbe avere una miniatura YouTube?`)
};

const pt_br2_yt_hd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual resolução uma thumbnail do YouTube deveria ter?`)
};

const pt_yt_hd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qual deve ser a resolução de uma miniatura do YouTube?`)
};

const ja_yt_hd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTubeサムネイルはどの解像度にすべき？`)
};

const zh_yt_hd_faq4_q = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube 缩略图应该是多大分辨率？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hd_faq4_q = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hd_faq4_q(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hd_faq4_q", locale)
	if (locale === "en") return en_yt_hd_faq4_q(inputs)
	if (locale === "es") return es_yt_hd_faq4_q(inputs)
	if (locale === "de") return de_yt_hd_faq4_q(inputs)
	if (locale === "nl") return nl_yt_hd_faq4_q(inputs)
	if (locale === "fr") return fr_yt_hd_faq4_q(inputs)
	if (locale === "it") return it_yt_hd_faq4_q(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hd_faq4_q(inputs)
	if (locale === "pt") return pt_yt_hd_faq4_q(inputs)
	if (locale === "ja") return ja_yt_hd_faq4_q(inputs)
	return zh_yt_hd_faq4_q(inputs)
};